export enum MembershipStatus {
  Active,
  Inactive,
}

export enum PlanType {
  Traditional,
  HSA,
}
